import React, { FC, isValidElement, ReactElement, ReactNode } from "react";
import classNames from "classnames";

import { Button } from "../Button";
import { SimpleAction } from "../../../types/GlobalTypes";

type Props = {
  title: string;
  description: string;
  action: SimpleAction | ReactElement;
  rightPlaceholder?: ReactNode;
  dataTest?: string;
  className?: string;
};

export const FeaturedBanner: FC<Props> = ({
  title,
  description,
  action,
  dataTest,
  className,
  rightPlaceholder,
}) => {
  return (
    <div
      className={classNames(
        "flex flex-col md:flex-row justify-between items-start gap-4 md:gap-24 rounded-2xl overflow-hidden",
        className
      )}
      data-test={dataTest}
    >
      <div className="flex flex-col justify-between min-gap-6 py-5 md:py-9 px-4 md:px-12 h-full">
        <div
          className="font-source-serif font-normal text-5xl"
          data-test={`${dataTest}-title`}
        >
          {title}
        </div>

        <div className="font-medium" data-test={`${dataTest}-description`}>
          {description}
        </div>

        {action && (
          <div>
            {isValidElement(action) ? (
              (action as ReactElement)
            ) : (
              <Button
                variant={Button.variant.PRIMARY}
                onClick={(action as SimpleAction).onClick}
                dataTest={`${dataTest}-action`}
              >
                {(action as SimpleAction).label}
              </Button>
            )}
          </div>
        )}
      </div>

      {rightPlaceholder}
    </div>
  );
};
